module.exports = __webpack_public_path__ + "static/media/Sofia-Pro-Medium.3e87cf37.ttf";